import * as React from "react";

import { cn } from "@/lib/utils";

export interface InputProps
    extends React.InputHTMLAttributes<HTMLInputElement> {
    otherProps?: null;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, type, ...props }, ref) => {
        return (
            <input
                type={type}
                className={cn(
                    "flex h-9 w-full rounded-full border border-neutral-200 bg-transparent px-3 py-1 text-sm shadow-sm transition-colors",
                    "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-neutral-950",
                    "placeholder:text-neutral-200 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-neutral-950",
                    "disabled:cursor-not-allowed disabled:opacity-50",
                    "bg-white text-navy border-sage-foreground font-medium",
                    "dark:bg-sage dark:text-offwhite dark:border-sage-foreground dark:file:text-offwhite dark:placeholder:text-neutral-300 dark:focus-visible:ring-neutral-300",
                    className
                )}
                ref={ref}
                {...props}
            />
        );
    }
);
Input.displayName = "Input";

export { Input };
